import { call, put, takeLatest, cancelled, all } from "redux-saga/effects";
import { evaluation } from "../api/drivers/evaluation";
import * as evaluationActions from "../actions/evaluation";
import * as authActions from "../actions/auth";

function* getInspectorFilters(action) {
  try {
    const res = yield call(evaluation.getInspectorFilters, action.payload);
    yield put({
      type: evaluationActions.GET_INSPECTOR_FILTERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: evaluationActions.GET_INSPECTOR_FILTERS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401)
      yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log("getInspectorFilters cancelled");
    }
  }
}

function* getInspectorEvaluation(action) {
  try {
    const res = yield call(evaluation.getInspectorEvaluation, action.payload);
    yield put({
      type: evaluationActions.EVALUATE_INSPECTORS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: evaluationActions.EVALUATE_INSPECTORS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401)
      yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log("evaluateInspectors cancelled");
    }
  }
}

function* getSupervisorFilters(action) {
  try {
    console.log("Calling supervisor filters");
    const res = yield call(evaluation.getSupervisorFilters, action.payload);
    yield put({
      type: evaluationActions.GET_SUPERVISOR_FILTERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: evaluationActions.GET_SUPERVISOR_FILTERS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401)
      yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log("getSupervisorFilters cancelled");
    }
  }
}

function* getSupervisorEvaluation(action) {
  try {
    const res = yield call(evaluation.getSupervisorEvaluation, action.payload);
    yield put({
      type: evaluationActions.EVALUATE_SUPERVISORS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: evaluationActions.EVALUATE_SUPERVISORS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401)
      yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log("evaluateSupervisors cancelled");
    }
  }
}

function* getMunicipalityFilters(action) {
  try {
    const res = yield call(evaluation.getMunicipalityFilters, action.payload);
    yield put({
      type: evaluationActions.GET_MUNICIPALITY_FILTERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: evaluationActions.GET_MUNICIPALITY_FILTERS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401)
      yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log("getMunicipalityFilters cancelled");
    }
  }
}

function* getMunicipalityEvaluation(action) {
  try {
    const res = yield call(
      evaluation.getMunicipalityEvaluation,
      action.payload
    );
    yield put({
      type: evaluationActions.EVALUATE_MUNICIPALITY_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: evaluationActions.EVALUATE_MUNICIPALITY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401)
      yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log("evaluateMunicipality cancelled");
    }
  }
}

export default all([
  takeLatest(
    evaluationActions.GET_INSPECTOR_FILTERS_REQUEST,
    getInspectorFilters
  ),
  takeLatest(
    evaluationActions.EVALUATE_INSPECTORS_REQUEST,
    getInspectorEvaluation
  ),
  takeLatest(
    evaluationActions.GET_SUPERVISOR_FILTERS_REQUEST,
    getSupervisorFilters
  ),
  takeLatest(
    evaluationActions.EVALUATE_SUPERVISORS_REQUEST,
    getSupervisorEvaluation
  ),
  takeLatest(
    evaluationActions.GET_MUNICIPALITY_FILTERS_REQUEST,
    getMunicipalityFilters
  ),
  takeLatest(
    evaluationActions.EVALUATE_MUNICIPALITY_REQUEST,
    getMunicipalityEvaluation
  ),
]);
